var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostModellingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88457 18V15.85C3.00124 15.65 2.23874 15.2667 1.59707 14.7C0.955404 14.1333 0.48457 13.3333 0.18457 12.3L2.03457 11.55C2.28457 12.35 2.6554 12.9583 3.14707 13.375C3.63874 13.7917 4.28457 14 5.08457 14C5.7679 14 6.34707 13.8458 6.82207 13.5375C7.29707 13.2292 7.53457 12.75 7.53457 12.1C7.53457 11.5167 7.35124 11.0542 6.98457 10.7125C6.6179 10.3708 5.7679 9.98333 4.43457 9.55C3.00124 9.1 2.0179 8.5625 1.48457 7.9375C0.951237 7.3125 0.68457 6.55 0.68457 5.65C0.68457 4.56667 1.03457 3.725 1.73457 3.125C2.43457 2.525 3.15124 2.18333 3.88457 2.1V0H5.88457V2.1C6.7179 2.23333 7.4054 2.5375 7.94707 3.0125C8.48874 3.4875 8.88457 4.06667 9.13457 4.75L7.28457 5.55C7.08457 5.01667 6.80124 4.61667 6.43457 4.35C6.0679 4.08333 5.5679 3.95 4.93457 3.95C4.20124 3.95 3.6429 4.1125 3.25957 4.4375C2.87624 4.7625 2.68457 5.16667 2.68457 5.65C2.68457 6.2 2.93457 6.63333 3.43457 6.95C3.93457 7.26667 4.80124 7.6 6.03457 7.95C7.18457 8.28333 8.0554 8.8125 8.64707 9.5375C9.23874 10.2625 9.53457 11.1 9.53457 12.05C9.53457 13.2333 9.18457 14.1333 8.48457 14.75C7.78457 15.3667 6.9179 15.75 5.88457 15.9V18H3.88457Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostModellingIcon);
export default __webpack_public_path__ + "static/media/cost-modelling-icon.c94a9070478e8246c595259f05423ff5.svg";
export { ForwardRef as ReactComponent };